import _bcp47ToEbu from "../../dict/bcp47ToEbuLanguage.js";
const bcp47ToEbu = _bcp47ToEbu;
export default (function syncEncodeLanguageFromEventGroup(eventGroupId, profileKey, eventGroups, profileMapping) {
  if (!eventGroupId || !profileKey) {
    return;
  }
  const group = eventGroups.find(g => g.id === eventGroupId);
  const encodeOptions = profileMapping[profileKey]?.options?.encode;
  const langOption = encodeOptions?.find(option => option.name === "Language Code");
  if (!group?.language || !langOption) {
    return;
  }
  if (langOption.type === "list") {
    const mapped = bcp47ToEbu.bcp47ToEbuLanguageName(group.language);
    if (mapped && langOption.values.includes(mapped)) {
      langOption.selected = mapped;
    }
    return;
  }
  langOption.selected = group.language;
});